import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { getSessionId } from '../../../helpers/storageUtils';
import { CrearCotizacion } from '../../../Models/crearCotizacion';
import { DatosGenerales } from '../../../Models/datosGenerales';
import { DatosPlanes } from '../../../Models/datosPlanes';
import { LOADER } from '../../../routes.constans';
import { DataLayerService } from '../../../services/DataLayer/data-layer.service';
import { InactivityService } from '../../../services/inactivity/inactivity.service';
import { selectCotizacion } from '../../../storage/Cotizacion/cotizacion.selectors';
import { selectData } from '../../../storage/Lead/data.selectors';
import { selectPlanes } from '../../../storage/Planes/planes.selector';
import { BannerAppComponent } from '../../banner-app/banner-app.component';
import { FooterAppComponent } from '../../footer-app/footer-app.component';

@Component({
  selector: 'app-no-es-soat',
  standalone: true,
  imports: [BannerAppComponent, FooterAppComponent],
  templateUrl: './no-es-soat.component.html',
  styleUrl: './no-es-soat.component.scss',
})
export class NoEsSoatComponent implements OnInit, OnDestroy {
  private inactivityService = inject(InactivityService);
  codAsesor = '';
  sessionId = '';
  datosGenerales: DatosGenerales | null = null;
  datosGenerales$: Observable<DatosGenerales | null>;

  datosPlanes: DatosPlanes | null = null;
  datosPlanes$: Observable<DatosPlanes | null>;

  datosCotizacion: CrearCotizacion | null = null;
  datosCotizacion$: Observable<CrearCotizacion | null>;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store: Store,
    private dataLayerService: DataLayerService,
  ) {
    this.datosGenerales$ = this.store.select(selectData);
    this.datosPlanes$ = this.store.select(selectPlanes);
    this.datosCotizacion$ = this.store.select(selectCotizacion);
    // Get codigoAsesor from query parameters
    this.route.queryParams.subscribe((params) => {
      this.codAsesor = params['codigoAsesor'] || '';
    });
  }

  ngOnInit(): void {
    this.sessionId = getSessionId().toString();

    this.inactivityService.stopTimer();

    this.inactivityService.startDefaultTimerForScreen('No-es-SOAT', 'Abandono No es SOAT', '5');

    this.datosGenerales$.subscribe((data) => {
      this.datosGenerales = data;
    });

    this.datosPlanes$.subscribe((data) => {
      this.datosPlanes = data;
      console.log('datos planes');
    });

    this.datosCotizacion$.subscribe((data) => {
      console.log('data cot', data);

      this.datosCotizacion = data;
    });

    this.pushDataLayer('Pageview');
  }

  continuar() {
    const queryParams = this.codAsesor ? { codigoAsesor: this.codAsesor } : {};
    this.pushDataLayer('Button');
    this.router.navigate([LOADER], { queryParams });
  }

  pushDataLayer(ecom_item: 'Pageview' | 'Button' | undefined, ecom_subitem = ''): void {
    this.dataLayerService.pushDataLayer({
      event: 'moto_ecommerce_step_1.5',
      ecom_tipo: 'Moto',
      ecom_item,
      ecom_subitem,
      ecom_pantalla: 'No es SOAT',
      user_id: this.sessionId,
    });
  }

  ngOnDestroy(): void {
    this.inactivityService.stopTimer();
  }
}
